const uuid = require('uuid/v4')
const state = {
  uuid: null, 
  remainingTime: null,
  habitTotalTime: 0,
  habits: [],
  /*
    {
      name: '',
      habitType: '', // 1. dayly 2. weekly 3. montly 4.custom
      hibitTime: 0,
      unit: null, // 1. sec 2. min 3. hour, 4. day
      uuid: null,
      caluclated: 0
    }
  */
}
const getters = {
  getHabits: (state) => state.habits
}
const mutations = {
  setHibit(state, {habitName, habitType, time, timeType}){

    // valicdation

    const tempHabit = {
      name: habitName,
      'habitType': parseInt(habitType),
      'timeType': parseInt(timeType),
      'time': parseInt(time),
      'uuid': uuid(),
      'habitTypeDisplayName': '',
      'timeTypeDisplayName': '',
      caluclated: 0
    }
    let unit = 0
    if(tempHabit.habitType === 1){
      unit = 365
      tempHabit.habitTypeDisplayName = 'Daily' 
    }
    if(tempHabit.habitType === 2){
      unit = 52   
      tempHabit.habitTypeDisplayName = 'Weekly' 
    }
    if(tempHabit.habitType === 3){
      unit = 12   
      tempHabit.habitTypeDisplayName = 'Monthly' 
    } 

    // sec
    if(tempHabit.timeType === 1){
      tempHabit.caluclated = Math.round((((time * unit) / 60) / 60 ) / 24)
      tempHabit.timeTypeDisplayName = 'sec'
    }
    // min
    if(tempHabit.timeType === 2){
      tempHabit.caluclated = Math.round(((time * unit) / 60) / 24)
      tempHabit.timeTypeDisplayName = 'min'
    }
    // hour
    if(tempHabit.timeType === 3){
      tempHabit.caluclated = Math.round((time * unit) / 24)
      tempHabit.timeTypeDisplayName = 'hour'
    }
    // day
    if(tempHabit.timeType === 4){
      tempHabit.caluclated = (time * unit)
      tempHabit.timeTypeDisplayName = 'day'
    }

    state.habits.push(tempHabit)
    console.log(state.habits)
  }
}
const actions = {
  setHibit(context, {habitName, habitType, time, timeType}){ context.commit('setHibit', {habitName, habitType, time, timeType})}
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 
